import { FiltersConfig } from '../../../../../../../components/FilterGroup';

export const RANKING_SCHOOLS_TABLE_FILTERS: FiltersConfig = {
  participationStatus: {
    title: 'Response',
    subTitle: 'Also applies for download',
    options: [],
  },
};
